
import { SaleLayoutConf } from "@/models/sale-layout";
import { DossierConfigService } from "@/services/dossier-config-service";
import { SaleService } from "@/services/sale-service";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";
import Vue from "vue";
import VueI18n from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			saleLayouts: [] as SaleLayoutInfo[],
		};
	},
	props: {
		value: {
			type: [Array, Object as () => SaleLayoutConf, Number],
		},
		id: {type: Boolean},
		label: {
			type: [Object as () => VueI18n.TranslateResult, String],
		},
		fancy: Boolean,
		addDefaultOption: Boolean,
		saleTypeId: Number,
		contactGroupId: Number,
		multi: Boolean
	},
	computed: {
		saleLayoutItems(): ISelectItem<SaleLayoutInfo | undefined | number>[] {
			if (!this.saleLayouts) {
				return [];
			}
			let result = [] as ISelectItem<SaleLayoutInfo | undefined | number>[];
			if (this.addDefaultOption) {
				let text = "use-default";
				if (this.defaultSaleTypeName) {
					text = "use-default-with-name";
				}
				result.push({
					text: this.$ct(text, {name: this.defaultSaleTypeName}),
					value: this.id ? 0 : undefined
				});
			}
			let items = [...this.saleLayouts];
			if (this.saleTypeId){
				let config = DossierConfigService.getSaleConfig(this.saleTypeId);
				items = items.filter(l=>{
					return config.AvailableLayoutIDs.indexOf(l.ID) != -1;
				});
			}
			if (this.contactGroupId > 0) {
				items = items.filter(l=>l.ContactGroupID == this.contactGroupId);
			}
			return result.concat(items.map(s => {
				return {
					text: s.Name,
					value: this.id ? s.ID : s
				};
			}));
		},

		_value(): SaleLayoutInfo | undefined | number{
			if (typeof(this.value) == "object" && Array.isArray(this.value)){
				return undefined;
			}
			if (this.id) {
				return this.value;
			}
			if (!this.value){
				return undefined;
			}
			return this.saleLayouts.find(s=>s.ID == (this.value as SaleLayoutInfo).ID);
		},

		_label(): string | VueI18n.TranslateResult {
			return this.label || this.$t("label");
		},

		defaultSaleTypeName():string {
			if (!this.saleTypeId) {
				return "";
			}
			let config = DossierConfigService.getSaleConfig(this.saleTypeId);
			let layout = this.saleLayouts.find(s => s.ID == config.DefaultLayoutID);
			if (layout) {
				return layout.Name;
			}
			return "";
		}
	},
	methods: {
		onInput(layout?: SaleLayoutInfo | undefined | number) {
			return this.$emit("input", layout);
		}
	},
	async created() {
		this.saleLayouts = await SaleService.getSaleLayouts();
	},
	i18nEx: {
		componentPrefix: "components.SelectSaleLayout"
	}
});
